<template>
  <div class="rate-rules">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Regras Tarifárias">
      <!-- SIDEBAR -->
      <template v-slot:sidebar>
        <InfoPanel height="55" class="pmw-page-actions--blue-box">
          <template v-slot:content>
            <!-- NOME DO HOTEL -->
            <Heading v-if="hotel" class="pmw-page-actions--blue-box-text">
              {{ hotel.nome }}
            </Heading>
          </template>
        </InfoPanel>

        <SidebarBlock class="pmw-page-actions--title">
          <!-- MENU DOS HOTÉIS -->
          <PmwHotelNav
            :links="menuLinks"
            :hide="isHotelAbsolute ? ['diferenciais', 'banners'] : ['banners']"
            active="yields"
            class="menu-nav"
          />

          <Heading element="h2" class="pmw-sidebar-title">
            Ações da página
          </Heading>

          <!-- BOTÃO DE CRIAR FLUTUAÇÃO -->
          <PmwButton
            variation="blue-100"
            class="pmw-page-actions--button"
            hasIcon
            @click="openRateCreation"
          >
            Criar regra
          </PmwButton>

          <!-- BOTÃO DE RESUMO DE FLUTUAÇÃO - ATIVO QUANDO SELECIONADO UM ITEM DA TABELA -->
          <PmwButton
            :disabled="selectedRows.length < 1 || selectedRows.length >= 2"
            variation="blue-100"
            class="pmw-page-actions--button"
            icon="info"
            hasIcon
            @click="openResume(selectedRows[0])"
          >
            Resumo da regra
          </PmwButton>

          <!-- BOTÃO DE EDITAR - ATIVO QUANDO SELECIONADO UM ITEM DA TABELA -->
          <PmwButton
            :disabled="selectedRows.length < 1 || selectedRows.length >= 2"
            variation="blue-100"
            class="pmw-page-actions--button"
            @click="editRule(selectedRows[0].codigo, selectedRows[0].master)"
          >
            Editar
          </PmwButton>

          <!-- BOTÃO DE DUPLICAR - ATIVO QUANDO SELECIONADO UM ITEM DA TABELA -->
          <PmwButton
            :disabled="selectedRows.length < 1 || selectedRows.length >= 2"
            variation="blue-100"
            class="pmw-page-actions--button"
            @click="
              duplicateRule(selectedRows[0].codigo, selectedRows[0].master)
            "
          >
            Duplicar
          </PmwButton>

          <!-- BOTÃO LADO A LADO -->
          <div class="pmw-page-actions--side">
            <!-- BOTÃO DE RESERVAS - ATIVO QUANDO SELECIONADO UM ITEM DA TABELA -->
            <PmwButton
              :disabled="disableReservationButton"
              :tooltipText="reservationTooltip"
              :tooltipMinWidth="120"
              popperPosition="top-start"
              variation="blue-100"
              class="pmw-page-actions--side-button"
              @click="goToReservations(selectedRows[0])"
            >
              Reservas
            </PmwButton>

            <!-- BOTÃO DE LINK PÚBLICO - ATIVO QUANDO SELECIONADO UM ITEM DA TABELA -->
            <PmwButton
              :disabled="selectedRows.length < 1 || selectedRows.length >= 2"
              variation="blue-100"
              class="pmw-page-actions--side-button"
              @click="openPublicLink(selectedRows[0])"
            >
              Link Público
            </PmwButton>
          </div>

          <!-- BOTÃO INATIVAR -->
          <PmwButton
            v-show="showInactivateButton"
            :disabled="selectedRows.length < 1"
            variation="error-100"
            class="pmw-page-actions--button"
            @click="openDelete(selectedRows, 1)"
          >
            Inativar
          </PmwButton>

          <!-- BOTÃO REATIVAR -->
          <PmwButton
            v-show="false"
            :disabled="selectedRows.length < 1"
            variation="blue-100"
            class="pmw-page-actions--button"
            @click="openDelete(selectedRows, 1)"
          >
            Reativar
          </PmwButton>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template v-slot:content>
        <!-- SUBTITULO -->
        <div class="sub-title">
          <PmwParagraph size="paragraph-60">
            Selecione para excluir ou editar uma regra
          </PmwParagraph>
        </div>

        <!-- FILTROS -->
        <div class="filters">
          <PmwFilterCombinated
            :filters="selectedFilters"
            :fixedFilters="fixedFilters"
            :options="filterOptions"
            ref="pmwFilterCombinated"
            class="filters-combinated"
            @filter="getFilters"
          />
        </div>

        <!-- CONFIG COLUNAS -->
        <div class="d-flex justify-content-end">
          <PmwConfigDropDown
            v-model="selectedColumns"
            :configOptions="columnOptions"
            strategy="absolute"
            labelIcon="Configurar colunas da tabela"
            class="rate-rules--table-config-btn"
          />
        </div>

        <!-- TABELA -->
        <div class="table">
          <DataTable
            :cols="tableVisibleColumns"
            :rows="tableRows"
            :isLoading="isLoading"
            :colsMinWidths="tableColsWidth"
            selectableRow
            class="datatable"
            ref="datatable"
            @getSelectedRows="selectedRows = $event"
          >
            <!-- COLUNA DE MASTER -->
            <template v-slot:nome="data">
              <div class="name">
                <div :title="data.rowDataObj.nome" class="name--text">
                  {{ data.rowDataObj.nome }}
                </div>

                <div v-if="data.rowDataObj.isCrm" class="name--crm">CRM</div>

                <!-- PMWBRALB-17918: Ícone de indisponibilidade temporariamente desabilitado -->
                <div
                  v-if="false && data.rowDataObj.indisponivel"
                  class="name--tooltip"
                >
                  <PmwInfoTooltip icon="alert" width="250px">
                    <template #content>
                      <div>
                        Não encontramos disponibilidade para esta tarifa nos
                        primeiros noventa dias após o seu check-in. Por favor,
                        ajuste essa tarifa e tentaremos encontrá-la novamente.
                      </div>
                    </template>
                  </PmwInfoTooltip>
                </div>
              </div>
            </template>

            <!-- COLUNA DE NOME PÚBLICO -->
            <template v-slot:nomePublico="data">
              <div :title="data.rowDataObj.nomePublico" class="nome-publico">
                {{ data.rowDataObj.nomePublico }}
              </div>
            </template>

            <!-- COLUNA DE MASTER -->
            <template v-slot:master="data">
              <div class="master">
                <!-- CASO SEJA TRUE-->
                <span v-if="data.rowDataObj.master"> Sim </span>
                <!-- CASO SEJA FALSE -->
                <span v-else> Não </span>
              </div>
            </template>

            <!-- COLUNA DE PRIORIDADE-->
            <template v-slot:priori="data">
              <div class="priori">
                <!-- CASO SEJA TRUE -->
                <span v-if="data.rowDataObj.priori"> Sim </span>
                <!-- CASO SEJA FALSE -->
                <span v-else> - </span>
              </div>
            </template>

            <!-- COLUNA DE PERMANENCIA -->
            <template v-slot:perman="data">
              <div
                v-if="
                  data.rowDataObj.permanMin !== '' ||
                    data.rowDataObj.permanMax !== ''
                "
                class="perman"
              >
                {{ data.rowDataObj.permanMin }} -
                {{ data.rowDataObj.permanMax }}
              </div>
              <div v-else>-</div>
            </template>

            <!-- COLUNA DE ANTECEDENCIA -->
            <template v-slot:anteced="data">
              <div v-if="data.rowDataObj.antecedMin !== ''" class="anteced">
                {{ data.rowDataObj.antecedMin }} -
                {{ data.rowDataObj.antecedMax }}
              </div>
              <div v-else>-</div>
            </template>

            <!-- COLUNA DE HOSPEDAGEM -->
            <template v-slot:hospedagem="data">
              <div
                v-if="data.rowDataObj.hospedagem.length < 2"
                class="hospedagem"
              >
                {{ data.rowDataObj.hospedagemInicio }} -
                {{ data.rowDataObj.hospedagemFim }}
              </div>
              <div v-else-if="data.rowDataObj.hospedagem.length >= 2">
                Múltiplos períodos
              </div>
            </template>

            <!-- COLUNA DE STATUS -->
            <template v-slot:status="data">
              <div class="status">
                <!-- BOLINHA DE STATUS -->
                <i
                  :style="{
                    background: getColorStatus(data.rowDataObj.status)
                  }"
                  class="status--bullet"
                />

                <div v-if="data.rowDataObj.status">Ativo</div>
                <div v-else>Inativo</div>
              </div>
            </template>

            <!-- COLUNA DE STATUS -->
            <template v-slot:acoes="data">
              <Dropdown class="dots" position="bottom-end" strategy="absolute">
                <template #button-content>
                  <Icon icon="dots" class="dots-itens" />
                </template>
                <!-- INFORMAÇÕES -->
                <DropdownItem
                  class="dots-text"
                  element="button"
                  @click.stop.prevent="openResume(data.rowDataObj)"
                >
                  Resumo
                </DropdownItem>

                <!-- EDITAR -->
                <DropdownItem
                  class="dots-text"
                  element="button"
                  @click.stop.prevent="
                    editRule(data.rowDataObj.codigo, data.rowDataObj.master)
                  "
                >
                  Editar
                </DropdownItem>

                <!-- DUPLICAR -->
                <DropdownItem
                  class="dots-text"
                  element="button"
                  @click="
                    duplicateRule(
                      data.rowDataObj.codigo,
                      data.rowDataObj.master
                    )
                  "
                >
                  Duplicar
                </DropdownItem>

                <!-- LINK PÚBLICO -->
                <DropdownItem
                  class="dots-text"
                  element="button"
                  @click.stop.prevent="openPublicLink(data.rowDataObj)"
                >
                  Link público
                </DropdownItem>

                <!-- INATIVAR CUPOM ÚNICO -->
                <DropdownItem
                  v-show="data.rowDataObj.status"
                  class="dots-text-danger"
                  element="button"
                  @click.stop.prevent="openDelete(data.rowDataObj.codigo, 2)"
                >
                  Inativar
                </DropdownItem>

                <!-- REATIVAR CUPOM ÚNICO -->
                <DropdownItem
                  v-show="false"
                  class="dots-text-normal"
                  element="button"
                  @click.stop.prevent="openDelete(data.rowDataObj.codigo, 2)"
                >
                  Reativar
                </DropdownItem>
              </Dropdown>
            </template>
          </DataTable>

          <!-- PAGINAÇÃO -->
          <PmwPagination
            :items="paginationItens"
            :itemsPerPage="pagination.itemsPerPage"
            :currentPage="pagination.currentPage"
            :totalItems="paginationItens.length"
            :itemsPerPageOptions="pagination.itemsPerPageOptions"
            class="pagination"
            @changePagination="changePagination"
          />
        </div>

        <!-- GRÁFICO -->
        <div v-if="status !== false" class="graph">
          <ActiveFluctuationRates :reportData="filteredChartData" />
        </div>

        <!-- MODAIS -->

        <!-- MODDAL - LINK PUBLICO -->
        <div id="public-link-modal">
          <PmwModal
            v-if="singleData !== null"
            v-model="showLinkModal"
            :description="singleData.nome"
            :width="'850px'"
            title="Link público da regra"
            cancelButtonText=""
            confirmButtonText="Fechar"
            buttonAlignment="end"
            buttonClose
            @modal-confirm="singleData = null"
            @modal-cancel="singleData = null"
          >
            <template>
              <!-- LINK PÚBLICO -->
              <div class="public-link">
                <div class="public-link-item" @click="openAccord(1)">
                  <PmwAccordion class="pmw-accordion">
                    <PmwAccordionItem
                      :startOpen="false"
                      title="Link Público"
                      description=""
                      ref="accordion-1"
                      class="pmw-accordion--item"
                    >
                      <template v-slot:content>
                        <div
                          v-for="linkPublico in singleData.linksPublico"
                          :key="linkPublico"
                        >
                          <div class="public-link--link">
                            <span class="public-link--link-text">
                              {{ baseUrl }}/reserva/link-publico?r={{
                                linkPublico
                              }}
                            </span>

                            <!-- BOTÃO DE COPIAR -->
                            <PmwButton
                              variation="blue-100"
                              size="small"
                              layout="outline"
                              class="public-link--copy"
                              @click.stop.prevent="
                                copyLink(
                                  `${baseUrl}/reserva/link-publico?r=${linkPublico}`
                                )
                              "
                            >
                              Copiar
                            </PmwButton>
                          </div>
                        </div>
                      </template>
                    </PmwAccordionItem>
                  </PmwAccordion>
                </div>

                <div class="public-link-item" @click="openAccord(2)">
                  <PmwAccordion class="pmw-accordion">
                    <PmwAccordionItem
                      :startOpen="false"
                      title="Cód. Link Público"
                      description=""
                      ref="accordion-2"
                      class="pmw-accordion--item"
                    >
                      <template v-slot:content>
                        <div
                          v-for="codLinkPublico in singleData.linksPublico"
                          :key="codLinkPublico"
                        >
                          <div
                            class="public-link--link"
                            @click.stop.prevent="
                              copyLink(`link-publico?r=${codLinkPublico}`)
                            "
                          >
                            <span class="public-link--link-text">
                              link-publico?r={{ codLinkPublico }}
                            </span>

                            <!-- BOTÃO DE COPIAR -->
                            <PmwButton
                              variation="blue-100"
                              size="small"
                              layout="outline"
                              class="public-link--copy"
                              @click.stop.prevent="
                                copyLink(`link-publico?r=${codLinkPublico}`)
                              "
                            >
                              Copiar
                            </PmwButton>
                          </div>
                        </div>
                      </template>
                    </PmwAccordionItem>
                  </PmwAccordion>
                </div>
              </div>
            </template>
          </PmwModal>
        </div>

        <!-- MODDAL - RESUMO DA FLUTUAÇÃO -->
        <div id="rules-resume-modal">
          <PmwModal
            v-if="singleData !== null"
            v-model="showResumeModal"
            :title="singleData.nome"
            :hasFooter="false"
            :width="'551px'"
            cancelButtonText=""
            confirmButtonText=""
            buttonClose
            @modal-confirm="singleData = null"
            @modal-cancel="singleData = null"
          >
            <template>
              <!-- RESUMO -->
              <div class="rules-resume">
                <!-- INFORMAÇÕES BÁSICAS -->
                <span class="rules-resume--text">
                  Tarifa prioritária
                  <span
                    v-if="singleData.prioritaria"
                    class="rules-resume--true"
                  >
                    Sim
                  </span>
                  <span v-else class="rules-resume--false"> Não </span>
                </span>

                <span class="rules-resume--text">
                  Código de tarifa
                  <span
                    v-if="singleData.codigoTarifa"
                    class="rules-resume--true"
                  >
                    Sim
                  </span>
                  <span v-else class="rules-resume--false"> Não </span>
                </span>

                <span class="rules-resume--text">
                  Allot por acomodação
                  <span v-if="singleData.allotment" class="rules-resume--true">
                    Sim
                  </span>
                  <span v-else class="rules-resume--false"> Não </span>
                </span>

                <!-- DADOS DE DATAS -->
                <div class="rules-resume">
                  <!-- PERIODO DE RESERVA -->
                  <div
                    v-if="
                      singleData.dataReservaInicio !== null ||
                        singleData.dataReservaFim !== null
                    "
                  >
                    <div class="rules-resume--text__date-title">
                      Período de reserva
                    </div>
                    <div>
                      {{ formatDate(new Date(singleData.dataReservaInicio)) }} -
                      {{ formatDate(new Date(singleData.dataReservaFim)) }}
                    </div>
                  </div>

                  <!-- BLACKOUT -->
                  <div v-if="singleData.datasBlackout.length >= 1">
                    <div class="rules-resume--text__date-title">Blackout</div>
                    <span
                      v-for="data in singleData.datasBlackout"
                      :key="data.index"
                      class="rules-resume--text__date"
                    >
                      {{ formatDate(new Date(data.dataInicio)) }} -
                      {{ formatDate(new Date(data.dataFim)) }}
                    </span>
                  </div>

                  <!-- PERIODO DE HOSPEDAGEM -->
                  <div v-if="singleData.resumoDatasHospedagem.length >= 1">
                    <div class="rules-resume--text__date-title">
                      Período de hospedagem
                    </div>
                    <span
                      v-for="data in singleData.resumoDatasHospedagem"
                      :key="data.index"
                      class="rules-resume--text__date"
                    >
                      {{ formatDate(new Date(data.dataInicio)) }} -
                      {{ formatDate(new Date(data.dataFim)) }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </PmwModal>
        </div>

        <!-- MODAL DE DELEÇÃO -->
        <div>
          <PmwAlertModal
            v-model="showDeleteModal"
            title="Inativar regra"
            icon="pmw-trash-can"
            iconColor="red-80"
            cancelButtonColor="grey-100"
            confirmButtonColor="error-100"
            closeButton
            @alert-modal-cancel="closeDeleteModal()"
            @alert-modal-confirm="disableRules()"
          >
            <template #text>
              Após inativar essa regra, ela não ficará mais disponível. Você tem
              certeza que quer fazer isso?
            </template>
          </PmwAlertModal>
        </div>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
/** Componentes */

/** Locais */
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import hotelCommonsMixin from '@/mixins/hotelCommonsMixin'
import ActiveFluctuationRates from '@/components/hotel/rates/rateFluctuations/ActiveFluctuationRates.vue'
import copyIcon from '@/assets/icons/copy.svg'
import { formatDate } from '@/helpers/date'
import { capitalizeString } from '@/helpers/string'

/** Biblioteca */
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import Dropdown from '@solucoes/components-lib-tmp/src/components/patterns/Dropdown'
import DropdownItem from '@solucoes/components-lib-tmp/src/components/patterns/Dropdown/DropdownItem'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwFilterCombinated from '@solucoes/components-lib-tmp/src/components/patterns/PmwFilterCombinated'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import PmwModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwModal'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'
import PmwAccordion from '@solucoes/components-lib-tmp/src/components/patterns/PmwAccordion'
import PmwAccordionItem from '@solucoes/components-lib-tmp/src/components/patterns/PmwAccordion/PmwAccordionItem'
import PmwConfigDropDown from '@/components/_base/patterns/PmwConfigDropDown.vue'

/** Define a data inicial como o dia atual */
const starDate = new Date()

/** Define a data final para daqui a um ano */
const aYearFromNow = new Date()
aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)
const endDate = aYearFromNow

export default {
  name: 'RateRuleList',
  mixins: [hotelCommonsMixin],
  components: {
    PmwButton,
    Heading,
    SidebarLayout2,
    SidebarBlock,
    InfoPanel,
    PmwParagraph,
    PmwFilterCombinated,
    DataTable,
    PmwPagination,
    Dropdown,
    DropdownItem,
    PmwModal,
    PmwAlertModal,
    PmwInfoTooltip,
    PmwAccordion,
    PmwAccordionItem,
    ActiveFluctuationRates,
    PmwConfigDropDown
  },
  data() {
    const tableColsJSON = [
      {
        alias: 'Nome Público',
        name: 'nomePublico',
        index: 5
      },
      {
        alias: 'Master',
        name: 'master',
        index: 10
      },
      {
        alias: 'Priorit.',
        name: 'priori',
        index: 20
      },
      {
        alias: 'Coefic. (%)',
        name: 'coefic',
        index: 30
      },
      {
        alias: 'Perman. (RN)',
        name: 'perman',
        index: 40,
        sortable: false
      },
      {
        alias: 'Anteced.',
        name: 'anteced',
        index: 50,
        sortable: false
      },
      {
        alias: 'Hospedagem',
        name: 'hospedagem',
        index: 60,
        sortable: false
      },
      {
        alias: 'Status',
        name: 'status',
        index: 70
      }
    ]

    return {
      /** Caminho de pão */
      breadcrumb: [],

      /** Base url usado no link publico */
      baseUrl: null,

      /** Informações do hotel */
      hotel: null,

      /** Controle de visualização do modal de link público */
      showLinkModal: false,

      /** Controle de visualização do modal de resumo de regra */
      showResumeModal: false,

      /** Controle de visualização do modal de resumo de deleção */
      showDeleteModal: false,

      /** Define se é desabilitado pela listagem ou barra lateral*/
      disableType: false,

      /** Ids de flutuações a serem desativadas */
      deleteRulesId: null,

      /** Dados apenas da regras selecionada.  */
      singleData: null,

      /** Icone de copia */
      copyIcon: copyIcon,

      /** Filtros selecionados */
      selectedFilters: [],

      /** Controla o carregar da tabela */
      isLoading: true,

      /** Texto da tooltip do botão de reservas */
      reservationTooltip: '',

      /** Colunas da tabela */
      tableCols: [
        {
          alias: 'Nome',
          name: 'nome',
          index: 0
        }
      ],

      /** Dados da tabela */
      tableRows: [],

      /** Array das linhas selecionadas */
      selectedRows: [],

      /** Dados da paginação */
      paginationItens: [],

      /** Dados dos filtros */
      status: true,
      hospedagem: {},
      regra: null,

      columnOptions: [...tableColsJSON.filter((item) => item.name !== 'nome')],

      selectedColumns: [
        ...tableColsJSON.filter((item) => item.name !== 'nomePublico')
      ],

      /** Largura das colunas da tabela */
      tableColsWidth: {
        nome: '250px',
        nomePublico: '200px',
        master: '60px',
        priori: '60px',
        coefic: '60px',
        perman: '80px',
        anteced: '80px',
        hospedagem: '145px',
        status: '75px',
        acoes: '75px'
      },

      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 25,
        startItemIndex: 1,
        lastItemIndex: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },

      fixedFilters: [
        {
          options: ['hospedagem']
        }
      ],

      /** Dados de filtro */
      filterOptions: [
        {
          text: 'Nome interno',
          type: 'search',
          name: 'name',
          placeholder: 'Digite o nome da regra' /** opcional */,
          value: null /** opcional */
        },
        {
          text: 'Nome Público',
          type: 'search',
          name: 'nomePublico',
          placeholder: 'Digite o nome público da regra',
          value: null
        },
        /** Campo de seleção de status */
        {
          text: 'Status',
          type: 'select',
          name: 'status',
          description: 'Status' /** opcional */,
          search: false /** opcional */,
          options: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
          ],
          value: {
            text: 'Ativo',
            value: true
          } /** opcional */
        },
        {
          text: 'Periodo de Hospedagem',
          type: 'range',
          name: 'hospedagem',
          description: 'Entre',
          placeholder: '00/00/0000',
          value: {
            start: starDate,
            end: endDate
          }
        },
        {
          text: 'Tipo de Regra',
          type: 'select',
          name: 'regra',
          id: 'regra',
          description: 'Tipo de regra' /** opcional */,
          placeholder: 'Selecione o tipo de regra',
          options: [
            { text: 'Todas', value: 0 },
            { text: 'Públicas', value: 1 },
            { text: 'Não públicas', value: 2 },
            { text: 'CRM', value: 3 },
            { text: 'Código de tarifa', value: 4 },
            { text: 'Código corporativo', value: 5 }
          ],
          value: { text: 'Todas', value: 0 } /** opcional */
        },
        {
          text: 'Categorias tarifárias',
          type: 'select',
          name: 'codigoCategoria',
          id: 'categoriaTarifaria',
          description: 'Selecionar categorias',
          placeholder: 'Selecione o tipo de Categoria',
          options: [
            { text: 'Todas as categorias', value: -1 },
            { text: 'Tarifas sem categorias', value: 0 }
          ]
        },
        {
          text: 'Dispositivo',
          type: 'select',
          name: 'device',
          id: 'device',
          description: 'Selecione um dispositivo',
          placeholder: 'Selecione um dispositivo',
          options: [
            { text: 'Desktop', value: 0 },
            { text: 'Mobile', value: 1 },
            { text: 'Ambos', value: 2 }
          ]
        },
        {
          text: 'Allotment exclusivo',
          type: 'select',
          name: 'temAllotmentExclusivo',
          id: 'temAllotmentExclusivo',
          description: 'Possui allotment exclusivo?',
          placeholder: 'Selecione',
          options: [
            { text: 'Sim', value: true },
            { text: 'Não', value: false }
          ]
        }
      ],
      isHotelAbsolute: false,
      chartData: [],
      oldMasterRate: false
    }
  },

  computed: {
    showInactivateButton() {
      /** Exibição do botão de inativar */
      const isActive = this.selectedRows.some((item) => {
        return !item.status
      })
      if (!isActive) {
        return true
      }
      return false
    },

    /** Desabilita botão de reservas */
    disableReservationButton() {
      if (
        this.selectedRows?.length < 1 ||
        this.selectedRows?.length >= 2 ||
        !this.selectedRows[0]?.possuiReservaVinculada
      ) {
        this.addReservationTooltip()
        return true
      }
      return false
    },

    filteredChartData() {
      return this.chartData.filter((cItem) =>
        this.paginationItens.find((pItem) => pItem.codigo === cItem.codigo)
      )
    },

    tableVisibleColumns() {
      return [
        ...this.tableCols,
        ...this.selectedColumns,
        {
          alias: 'Ações',
          name: 'acoes',
          sortable: false
        }
      ].sort((a, b) => a.index - b.index)
    }
  },

  async created() {
    /** Limpa Session Storage */
    if (sessionStorage.length > 1) {
      sessionStorage.removeItem('hotelId')
      sessionStorage.removeItem('ruleId')
    }

    /** Retorno de dados do hotel */
    await this.$hotel.get(this.$route.params.id).then((response) => {
      this.hotel = response.data
      this.isHotelAbsolute = response.data.tarifarioAbsoluto

      /** Define o valor do breadcrumb */
      this.breadcrumb = [
        {
          label: 'Letsbook'
        },
        {
          label: 'Hotéis',
          url: '/hoteis',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: capitalizeString(this.hotel.nome),
          url: `/hoteis/editar/${this.hotel.codigo}`,
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        },
        {
          label: 'Configurações das regras tarifárias',
          url: '/',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ]
    })

    this.selectedFilters = [...this.selectedFilters]

    /** Fecha o filtro */
    this.$refs['pmwFilterCombinated'].filter()
  },

  async mounted() {
    await this.$nextTick()

    this.getRuleRateCategories()
  },

  methods: {
    /** Helper de data */
    formatDate: formatDate,

    /** Abre a criação em uma nova página */
    openRateCreation() {
      window.open(
        `/admin/v2/hoteis/regras-tarifarias/${this.$route.params.id}/novo`,
        '_blank'
      )
    },

    /** Controla a exibição dos itens do accord
     *  @param {Integer} index - Index do accordion clicado
     */
    openAccord(index) {
      if (index === 1) {
        this.$refs['accordion-2'].show
          ? this.$refs['accordion-2'].open()
          : false
      } else if (index === 2) {
        this.$refs['accordion-1'].show
          ? this.$refs['accordion-1'].open()
          : false
      }
    },

    /** Define o texto do tooltip do botão de reservas */
    addReservationTooltip() {
      if (
        this.selectedRows?.length === 1 &&
        !this.selectedRows[0]?.possuiReservaVinculada
      ) {
        this.reservationTooltip =
          'A regra selecionada não possui reservas vinculadas.'
      } else {
        this.reservationTooltip = ''
      }
    },

    /** Realiza o filtro dos dados através do nome */
    filterByName() {
      let results = null

      const filterByName = this.selectedFilters.find(
        (item) => item.name === 'name'
      )?.value

      if (filterByName !== undefined) {
        results = this.paginationItens.filter((data) => {
          return (
            data.nome.toLowerCase().indexOf(filterByName.toLowerCase()) > -1
          )
        })
      } else {
        results = this.paginationItens
      }

      this.paginationItens = results
    },

    /** Realiza o filtro dos dados através do nome público */
    filterByPublicName() {
      const filterValue = this.selectedFilters.find(
        (item) => item.name === 'nomePublico'
      )?.value

      if (filterValue === undefined || filterValue === null) return

      this.paginationItens = this.paginationItens.filter((data) => {
        const nomePublico = data.data?.nomePublico ?? data.nomePublico ?? ''
        return nomePublico.toLowerCase().indexOf(filterValue.toLowerCase()) > -1
      })
    },

    /** Item utilizado para retorno de dados dos filtros selecionados */
    getFilters() {
      /** Pegar o filtro de status */
      this.status = this.selectedFilters.find(
        (item) => item.name === 'status'
      )?.value.value

      /** Caso não tenha filtro de status, é pesquisado apenas os ativos */
      this.status === undefined || null ? (this.status = true) : null

      /** Pegar o filtro de regra */
      this.regra = this.selectedFilters.find(
        (item) => item.name === 'regra'
      )?.value.value

      /** Pega o filtro de hospedagem inicial */
      this.hospedagem.dataInicioHospedagem = this.selectedFilters.find(
        (item) => item.name === 'hospedagem'
      )?.value.start

      /** Pega o filtro de hospedagem final */
      this.hospedagem.dataFimHospedagem = this.selectedFilters.find(
        (item) => item.name === 'hospedagem'
      )?.value.end

      /** Chamada dos dados da listagem */
      this.getRuleRateList()

      /** Chamada dos dados do relatório */
      this.getActiveRates()
    },

    getRuleRateCategories() {
      this.$rate.getRateRuleCategories().then(({ data }) => {
        const target = this.filterOptions.find(
          (item) => item.name === 'codigoCategoria'
        )

        target.options.push(
          ...data.map(({ nome, codigo }) => ({ text: nome, value: codigo }))
        )
      })
    },

    /** Monta os dados dos filtros */
    getFiltersObject() {
      const filters = {}
      filters.dataInicioHospedagem = this.hospedagem.dataInicioHospedagem
      filters.dataFimHospedagem = this.hospedagem.dataFimHospedagem
      filters.apenasAtivas = this.status
      filters.tipoFlutuacaoTarifaria = this.regra
      filters.codigoHotel = this.hotel.codigo
      filters.codigoCategoria = this.selectedFilters?.find(
        (item) => item.name === 'codigoCategoria'
      )?.value?.value
      filters.device = this.selectedFilters?.find(
        (item) => item.name === 'device'
      )?.value?.value

      /** Filtro de Allotment exclusivo */
      const temAllotmentExclusivo = this.selectedFilters?.find(
        (item) => item.name === 'temAllotmentExclusivo'
      )?.value?.value
      if (temAllotmentExclusivo !== undefined) {
        filters.temAllotmentExclusivo = temAllotmentExclusivo
      }

      return filters
    },

    getActiveRates() {
      /** Limpa todos os itens selecionados */
      this.selectedRows = []

      const filters = this.getFiltersObject()

      /** Chamada da API */
      this.$rate.getActiveRates(filters).then((response) => {
        /** Ordenado pelas prioritárias primeiro */
        this.chartData = response.data.sort(
          (a, b) => Number(b.prioritaria) - Number(a.prioritaria)
        )
      })
    },

    /** Chamada dos dados da listagem */
    async getRuleRateList() {
      /** Ativa loading da tabela */
      this.isLoading = true

      /** Limpa todos os itens selecionados */
      this.selectedRows = []

      const filters = this.getFiltersObject()

      /** Chamada da API */
      await this.$rate
        .getRuleRateList(filters)
        .then((response) => {
          /** Ordena pelo nome e salva os dados retornados pela API */
          const results = response.data.sort((a, b) =>
            a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
          )

          /** Pega a URL do site */
          const url = new URL(window.location.href)
          const baseUrl = `${url.protocol}//${url.hostname}`
          this.baseUrl = baseUrl

          /** Mapeamento dos dados utilizados na listagem */
          results.map(function(key, index) {
            results[index]['data'] = {
              /** Dados */
              nome: key.nome,
              nomePublico: (() => {
                const ptBR = key.nomesPublicos?.find(
                  (n) => n.idioma === 'pt-BR'
                )
                return ptBR?.nome || key.nome
              })(),
              codigo: key.codigo,
              status: key.ativo,
              linksPublico: key.linkPublico,
              master: key.tarifaMaster,
              priori: key.prioritaria,
              coefic:
                key.tipoCoeficiente !== 1 && !key.isCoeficienteDiario
                  ? key.coeficiente
                  : '-',
              publica: key.publica,
              isCrm: key.isCrm,
              prioritaria: key.prioritaria,
              tarifaMaster: key.tarifaMaster,
              quartos: key.quartos,
              codigoTarifa: key.possuiCodigoTarifa,
              codigoTarifaMaster: key.codigoTarifaMaster,
              indisponivel: key.indisponivel,
              permanMax:
                key.permanenciaMaxima !== null ? key.permanenciaMaxima : '',
              permanMin:
                key.permanenciaMinima !== null ? key.permanenciaMinima : '',
              antecedMax:
                key.antecedenciaMaxima !== null ? key.antecedenciaMaxima : '',
              antecedMin:
                key.antecedenciaMinima !== null ? key.antecedenciaMinima : '',
              hospedagem:
                key.datasHospedagem !== null ? key.datasHospedagem : '-',
              resumoDatasHospedagem: key.datasHospedagem,
              datasBlackout: key.datasBlackout,
              dataReservaFim: key.dataReservaFim,
              dataReservaInicio: key.dataReservaInicio,
              possuiReservaVinculada: key.possuiReservaVinculada
            }

            /** Verifica e ajusta datas iniciais e finais de hospedagem */
            if (key.data.hospedagem.length >= 1) {
              key.data.hospedagemInicio = formatDate(
                new Date(key.data.hospedagem[0].dataInicio)
              )
              key.data.hospedagemFim = formatDate(
                new Date(key.data.hospedagem[0].dataFim)
              )
            } else if (key.data.hospedagem.length === 0) {
              key.data.hospedagemInicio = null
              key.data.hospedagemFim = null
            }
          })

          /** Atribui os dados para a tabela */
          this.paginationItens = response.data

          /** Verifica filtro por nome */
          this.filterByName()

          /** Verifica filtro por nome público */
          this.filterByPublicName()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.response.data
          })

          /** Abri o filtro para edição */
          this.$refs['pmwFilterCombinated'].hideFilters()
        })

      /** Remove loading da tabela */
      this.isLoading = false
    },

    /** Utilizado para criar regras
     * @param {Integer} codigo - Código da regra
     * @param {Boolean} master - Se a regra é master
     */
    duplicateRule(codigo, master) {
      this.isLoading = true

      this.$rate
        .duplicateRuleRate({ codigoFlutuacao: codigo })
        .then((response) => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Regra tarifária duplicada com sucesso.'
          })

          /** Encaminhamento para edição */
          this.editRule(response.data.codigo, master)

          this.getRuleRateList()
          this.getActiveRates()
          this.resetPagination()
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.response.data
          })

          this.getRuleRateList()
          this.getActiveRates()
          this.resetPagination()
        })
    },

    /** Redirecionar para a tela de edição antiga
     * @param {Integer} codigo - Código da regra
     * @param {Boolean} master - Se a regra é master
     */
    editRule(codigo, master) {
      if (master) {
        window.open(
          this.$router.resolve(
            `/hoteis/regras-tarifarias/${this.$route.params.id}/tarifa-master/${codigo}`
          ).href,
          '_blank'
        )
      } else {
        window.open(
          this.$router.resolve(
            `/hoteis/regras-tarifarias/${this.$route.params.id}/editar/${codigo}`
          ).href,
          '_blank'
        )
      }
    },

    /** Utilizado direcionamento para a tela de reservas.
     * @param {Array} data Dados da regra selecionada
     */
    goToReservations(data) {
      /** Salva os dados do filtro no sessionStorage */
      sessionStorage.setItem('hotelId', this.hotel.codigo)
      sessionStorage.setItem('ruleId', data.codigo)

      window.open('/admin/v2/reservas', '_blank')
    },

    /** Utilizado para abrir os dados da regra no model de link publico.
     * @param {Array} data Dados da regra selecionada
     */
    openPublicLink(data) {
      this.showLinkModal = true
      this.singleData = data
    },

    /** Utilizado para abrir os dados da regra no model de link publico.
     * @param {Array} data Dados da regra selecionada
     */
    openResume(data) {
      this.showResumeModal = true
      data.allotment = false

      if (data.quartos) {
        data.allotment = data.quartos.some((element) => {
          return element.allotment
        })
      }

      this.singleData = data
    },

    /** Utilizado para abrir modal de deleção
     * @param {Array} rules Itens a serem desativados
     * @param {Array} disableType Define se os dados são retornados da listagem (2) ou botão lateral (1)
     */
    openDelete(rules, disableType) {
      this.deleteRulesId = rules
      this.showDeleteModal = true
      this.disableType = disableType
    },

    /** Fecha o modal de deleção */
    closeDeleteModal() {
      this.singleData = null
      this.deleteRulesId = []
      this.disableType = null
      this.showDeleteModal = false
    },

    /** Desabilitar regras */
    disableRules() {
      this.isLoading = true

      /** Verifica se o comando é da tabela ou menu lateral */
      if (this.disableType === 2) {
        this.selectedRows = []
      }

      /** Armazena dados da regras a serem desativadas */
      const DeleteRules = this.ifExists(
        this.selectedRows.length > 0
          ? this.selectedRows.map((item) => {
              return parseInt(item.codigo)
            })
          : [this.deleteRulesId]
      )

      this.$rate
        .disableRuleRates({ flutuacoes: DeleteRules })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Regra tarifária desativada com sucesso.'
          })
          this.getRuleRateList()
          this.getActiveRates()
          this.resetPagination()
          this.selectedRows = []
          this.singleData = null
          this.deleteRulesId = []
          this.disableType = null
          this.showDeleteModal = false
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages[0]
          })
          this.isLoading = false
        })
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    },

    /** Utilizado para salvar conteudo do link
     * @param {String} item Texto do item a ser salvo
     */
    copyLink(item) {
      window.location.host.search(/^homologa(1|2|3):8080/) > -1
        ? document.execCommand('copy', item)
        : navigator.clipboard.writeText(item)

      this.$bus.$emit('show-alert-chip', {
        message: 'Link copiado com sucesso'
      })
    },

    /** Pegar a cor do bullet do status de pagamento
     * @param {Boolean} el identificação boleana de verdadeiro ou falso
     */
    getColorStatus(el) {
      switch (el) {
        case true:
          return '#21F384'
        case false:
          return '#E87178'
      }
    },

    /** Verificar se dado existe
     * @param {Array} element Item a ser verificado
     */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Usado para controle da paginação
     * @param {Array} childData Dados a serem passados para o componente de paginação
     */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.tableRows = childData.items
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-rules {
  &--table-config-btn {
    margin: 16px 0 0;
    float: none;
  }
}

.pmw-accordion {
  padding: 10px 24px 10px 33px;
  border-radius: 4px;
  background-color: $white;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.1);

  ::v-deep {
    .pmw-title-line {
      &--line {
        display: none;
      }

      &--title__text {
        color: pmw-colors(grey-80);
        font-size: font-size(size-large);
      }
    }
  }
}

.sub-title {
  padding-top: 5px;
  color: pmw-colors(grey-70);
}

.nome-publico {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.name {
  display: contents;

  &--text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 2px;
    width: -webkit-fill-available;
    line-height: 16px;
  }

  &--tooltip {
    z-index: 1;
    display: flex;
    position: inherit;
    color: pmw-colors(error-80);
    line-height: 18px;
    margin-left: 5px;
  }

  &--icon {
    visibility: hidden;
    width: 4px;
  }

  &--crm {
    display: inline;
    color: pmw-colors(grey-00);
    background-color: pmw-colors(secondary-100);
    border-radius: 24px;
    padding: 4px 8px;
    height: 16px;
    line-height: 10px;
    font-weight: font-weight(weight-medium);
    text-align: center;
  }
}

.filters {
  margin-top: 23px;
  background-color: pmw-colors(grey-00);
  border-radius: 3px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);

  &-combinated {
    ::v-deep {
      #pmwFilterCombined {
        #regra {
          .select-options--item__hover:nth-child(3) button {
            font-weight: font-weight(weight-medium);
          }

          .select-options--item__hover:nth-child(3) button::before {
            content: ' ';
            display: block;
            position: relative;
            bottom: 8px;
            border-top: 0.5px solid pmw-colors(grey-60);
            width: 115%;
            padding: 0px 0px 0px 0px;
            margin-left: -10px;
          }
        }
      }
    }
  }
}

.table {
  margin-top: 40px;
}

.public-link {
  &-item:nth-child(2) {
    margin-top: 24px;
  }

  &-cod {
    margin-top: 36px;
  }

  &--title {
    font-size: font-size(size-large);
    font-weight: font-weight(weight-medium);
    line-height: 21px;
  }

  &--link {
    display: flex;
    align-items: center;
    margin-top: 14px;
    font-size: font-size(size-large);
    font-weight: font-weight(weight-light);
    color: pmw-colors(grey-90);
    line-height: 24px;

    &-text {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 700px;
    }
  }

  &--copy {
    margin-left: 10px;
    display: inline-block;
    vertical-align: middle;
  }
}

.rules-resume {
  &--text {
    font-size: font-size(size-small);
    font-weight: font-weight(weight-medium);
    color: pmw-colors(grey-90);
    line-height: 18px;
    display: inline-block;
    margin-right: 32px;

    &__date {
      font-size: font-size(size-small);
      font-weight: font-weight(weight-normal);
      color: pmw-colors(grey-90);
      line-height: 18px;
      margin-right: 15px;
    }

    &__date-title {
      font-size: font-size(size-small);
      font-weight: font-weight(weight-medium);
      color: pmw-colors(grey-90);
      line-height: 18px;
      margin-top: 25px;
      margin-bottom: 3px;
    }
  }

  &--true {
    border-radius: 16px;
    height: 16px;
    width: 40px;
    padding: 2px 8px 2px 8px;
    font-size: font-size(size-small);
    font-weight: font-weight(weight-normal);
    color: pmw-colors(grey-90);
    text-align: center;
    background: pmw-colors(green-100);
  }

  &--false {
    border-radius: 16px;
    height: 16px;
    width: 40px;
    padding: 2px 8px 2px 8px;
    font-size: font-size(size-small);
    font-weight: font-weight(weight-normal);
    color: pmw-colors(grey-90);
    text-align: center;
    background: pmw-colors(red-60);
  }

  &--text:nth-child(3) {
    margin-right: 0px;
  }
}
.menu-nav {
  max-height: calc(100vh - 540px);
  overflow-y: scroll;
}
.pmw-sidebar {
  &-title {
    margin-bottom: 20px;
  }

  &-buttons {
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}

.status {
  display: flex;
  align-items: center;
  gap: 3px;

  &--bullet {
    min-width: 6px;
    height: 6px;
    margin-bottom: 1px;
    border-radius: 100%;
    display: block;
  }
}

.dots {
  margin: auto;

  &-itens {
    transform: rotate(90deg);
    width: 16px;
    height: 12px;
    color: pmw-colors(grey-90);
  }

  &-text {
    font-size: font-size(size-small);
    font-size: font-weight(weight-normal);

    &-danger {
      font-size: font-size(size-small);
      font-size: font-weight(weight-normal);
      color: $pmw-red-2;
    }
    &-danger:hover {
      font-size: font-size(size-small);
      font-size: font-weight(weight-normal);
      color: $pmw-red-2;
    }

    &-normal {
      font-size: font-size(size-small);
      font-size: font-weight(weight-normal);
      color: pmw-colors(blue-100);
    }
    &-normal:hover {
      font-size: font-size(size-small);
      font-size: font-weight(weight-normal);
      color: pmw-colors(blue-100);
    }
  }
}

.pmw-page-actions {
  &--blue-box {
    background-color: pmw-colors('blue-100');
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    line-height: 18px;
    text-align: center;

    ::v-deep {
      .heading {
        margin-bottom: 0;
      }
    }
  }
  &--blue-box-text {
    color: $pmw-white;
  }

  &--title {
    padding-top: 35px;
  }

  &--button {
    width: 100%;
    cursor: pointer;
    margin-bottom: 8px;

    & + .pmw-page-actions--button {
      margin-bottom: 8px;
    }
  }

  &--side {
    display: inline;
    & + .pmw-page-actions--button {
      margin-bottom: 8px;
    }

    &-button {
      width: 105px;
      margin-bottom: 8px;
      & + .pmw-page-actions--button {
        margin-bottom: 8px;
      }
      &__create {
        margin-bottom: 8px;
      }
    }

    &-button:first-of-type {
      margin-right: 4px;
    }

    &-button:last-of-type {
      margin-left: 4px;
    }
  }
}

::v-deep {
  .lb-breadcrumb--link:nth-child(2) {
    cursor: default;
  }

  .pmw-button--tooltip {
    width: 160px;
  }

  .content {
    /** Padding abaixo do título da página */
    .page-heading {
      padding-bottom: 10px;
    }
  }

  .month-picker-input {
    font-size: font-size(size-medium);
    padding-bottom: 8px;
  }

  .month-picker-input:focus {
    border-bottom-width: 2px;
    transition: border-bottom-width 0.1s;
    font-size: font-size(size-medium);
    border-color: pmw-colors(blue-100);
    box-shadow: 0 1px 1px transparent;
  }

  .pmw-dropdown {
    &-item {
      &:hover,
      &:active {
        background-color: $gray-lightest;
      }
    }
    .danger-color {
      &.dropdown-item {
        color: $pmw-red-2;
      }
    }

    &--options {
      min-width: 100px;
    }
  }

  &--quantity-column__danger-color {
    color: $pmw-red-2;
  }

  .pmw-td {
    padding: 14px 14px;
  }

  .pmw-dropdown-item {
    width: 100%;
  }
}

.datatable {
  max-height: initial;
  overflow: initial;
  border-bottom: none;

  &--pagination {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }

  ::v-deep {
    .pmw-row {
      .pmw-col {
        &:last-child {
          max-width: 75px;
        }
      }
    }

    .thead {
      top: 50px;

      &:before,
      &:after {
        content: '';
        width: 50px;
        height: 100%;
        position: absolute;
        top: 0;
        background-color: $white;
        right: 100%;
      }

      &::after {
        right: initial;
        left: 100%;
      }
    }
    .dropdown {
      &-item {
        &:hover,
        &:active {
          background-color: $gray-lightest;
        }
      }
      .danger-color {
        &.dropdown-item {
          color: $red-2;
        }
      }

      &--trigger-button {
        color: $gray-mid;
      }
      &--options {
        min-width: 100px;
      }
    }

    &--quantity-column__danger-color {
      color: $red-2;
    }
  }
}

.pagination {
  width: 100%;
  border-top: none;
  border-radius: 0;

  ::v-deep {
    .pmw-pagination {
      width: 100%;
    }
  }
}
</style>
